export { MousePointer as default } from './MousePointer';
